<template>
  <div>
    <vggrid ref="xGrid" :random="Math.floor(Math.random() * 999999)" :list="pgCrossList"
            tableheight="600" flexname="" :cols="pgCols"
            :showfooter="false" :showPage="false" :resizable="true"  :mergeRow='mergeRow'>
      <template slot="btn">
        <div class="exscore-topbtn">
          <div class="exscore-topbtn-title">评审人[{{pexpert.pexpertname}}]的评分过程</div>
          <div class="exscore-topbtn-btn">
            <el-button type="primary" size="small" :loading="btnLoading" @click="exportPDF" icon="el-icon-download">导出评分表PDF</el-button>
            <el-button type="primary" size="small" :loading="btnLoadingNew" @click="exportPDFNew" icon="el-icon-download">导出评分表PDF（监狱）</el-button>
          </div>
        </div>
      </template>
    </vggrid>

    <div class="split-line"></div>
    <div class="exscore-container">
      <vggrid :random="Math.floor(Math.random() * 999999)" :list="pgsList" flexname="" :cols="pgsCols"
              :showfooter="false" :showPage="false" :resizable="true"
              >
        <template slot="btn">
          <div class="exscore-topbtn">
            <div class="exscore-topbtn-title">评审人[{{pexpert.pexpertname}}]的评分汇总</div>
          </div>
        </template>
      </vggrid>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  import {ensurePdfLibs, exportTablePdf, RENDER_WIDTH} from '../../assets/js/pdfExport'
  export default {
    name: 'projectScoringComByEx',
    mixins: [common],
    components: {vggrid},
    props: {
      pexpert: {},
      projectid: {},
      pexpertid: {},
      activeName: {}
    },
    data () {
      return {
        // priceModel: '',
        project: {},
        list: [],
        scoreTotalList: [],
        selectList: [],
        pgsuList: [],
        psuComList: [],
        pgCrossList: [],
        pgsList: [],
        btnLoading: false,
        btnLoadingNew: false,
        model: {},
        isEdit: true,
        mergeRow:['pgratio','pgparentname','pgchildname'],
        editRules: {},
        pgsCols: [
          {field: 'comfullname', fieldtype: 'C', title: '供应商', calculExpr: '', addNewRowFlg: false},
          // {field: 'pgspriceasexchange', fieldtype: 'C', title: '价格得分', calculExpr: '', addNewRowFlg: false, width: 100},
          {field: 'pgscommercialasexchange', fieldtype: 'C', title: '评审得分', calculExpr: '', addNewRowFlg: false, width: 100},
          // {field: 'pgstechnologyasexchange', fieldtype: 'C', title: '技术得分', calculExpr: '', addNewRowFlg: false, width: 100},
          // {field: 'pgsas', fieldtype: 'C', title: '总分', calculExpr: '', addNewRowFlg: false, width: 100},
          // {field: 'pgsdesc', fieldtype: 'C', title: '评分意见', calculExpr: '', editRender: { name: 'input'}},
        ],
        pgCols: []
      }
    },
    async created () {
      await this.getModel()
      this.getPgCols()
      await this.getPgsuCrossList()

    },
    watch: {
      async pexpertid () {
        this.getPgCols()
        await this.getPgsuCrossList()
      }
    },
    methods: {
      // 交叉表的数据
      async getPgsuCrossList () {
        this.pgCrossList = []
        this.loading = true
        let project = {}
        project.projectisqcheck = this.project.projectisqcheck
        let res = await request({
          method: 'get',
          url: '/expert/getPgCrossByProjectId',
          params: {
            projectid: this.projectid,
            pexpertid: this.pexpertid,
            psupqcesresult: 1,
            projectisqcheck: this.project.projectisqcheck,
            project:project
          }
        })
        // 价格项
        // let priceList = res.pgList.filter(v => +v.pgflg === 1)
        // this.priceModel = priceList.length ? priceList[0] : ''
        // 非价格项
        this.pgCrossList = res.pgList.filter(v => +v.pgflg === 2)
        // 添加序号
        this.pgCrossList.forEach((item, index) => {
          item.serialNumber = index + 1
        })
        // this.pgCrossList = res.pgList
        this.pgsuList = res.pgsuList
        this.psuComList = res.psuList
        // 构造合计行数据
        this.setTotalRow(res)
        this.scoreTotalList = res.totalList
        await this.setCrossCols()
        await this.setPgsList()
        this.loading = false
      },
      // 构造合计行数据
      setTotalRow (res) {
        if (res.psuList.length) {
          let tree_total = res.tree.filter(v => +v.pgflg === 2)
          let totallist = res.pgsuList.filter(v => +v.pgflg === 2 && +v.pgsucomid == +res.psuList[0].psucomid)
          this.pgCrossList.push({
            pgparentname: '合计',
            pgratio: tree_total.map(t => Number(t.pgratio)).reduce((a, b) => a + b),
            pgscore: Number(totallist.map(t => Number(t.pgscore)).reduce((a, b) => a + b).toFixed(2))
          })
          res.psuList.forEach(com => {
            let comsuasList = this.pgsuList.filter(t => +t.pgsucomid === +com.psucomid && +t.pgflg === 2)
            this.pgsuList.push({
              pgsucomid: com.psucomid,
              pgsuas: Number(comsuasList.map(t => Number(t.pgsuas)).reduce((a, b) => a + b).toFixed(2)),
              pgname: '合计'
            })
          })
        }
      },
      // 我的预审结论数据
      async setPgsList() {
        await this.getPgsList()
      },
      getPgCols () {
        if (+this.project.projectpgstotalrule === 1) {
          this.pgCols = [
            {field: 'serialNumber', fieldtype: 'C', title: '序号', calculExpr: '', width: 60, issum: 0},
            // {field: 'pgparentname', fieldtype: 'C', title: '项目', calculExpr: ''},
            // {field: 'pgratio', fieldtype: 'C', title: '分值(百分比)', calculExpr: '',width: 100, issum: 0},
            {field: 'pgchildname', fieldtype: 'C', title: '子项', calculExpr: ''},
            {field: 'pgchildchildname', fieldtype: 'C', title: '二级（评审内容）', calculExpr: ''},
            {field: 'pgremark', fieldtype: 'C', title: '评分档次及依据', calculExpr: ''},
            {field: 'pgscore', fieldtype: 'C', title: '分值', calculExpr: '',width: 80, issum: 0}
          ]
        } else {
          this.pgCols = [
            {field: 'serialNumber', fieldtype: 'C', title: '序号', calculExpr: '', width: 60, issum: 0},
            // {field: 'pgparentname', fieldtype: 'C', title: '项目', calculExpr: ''},
            // {field: 'pgratio', fieldtype: 'F', title: '分值(绝对值)', calculExpr: '',width: 100, triggercol:1, issum: 0},
            {field: 'pgchildname', fieldtype: 'C', title: '一级（项目）', calculExpr: ''},
            {field: 'pgchildchildname', fieldtype: 'C', title: '二级（评审内容）', calculExpr: ''},
            {field: 'pgremark', fieldtype: 'C', title: '评分档次及依据', calculExpr: ''},
            {field: 'pgscore', fieldtype: 'F', title: '分值', calculExpr: '',width: 80, issum: 0},
          ]
        }
      },
      // 设置交叉表的表头
      async setCrossCols () {
        if (this.psuComList.length) {
          for(let i=0;i<this.psuComList.length;i++) {
            let item = this.psuComList[i]
            this.pgCols.push({
              title:item.comfullname,
              children: [
                {
                  slots: {
                    default: 'default',
                    default: ({row}) => {
                      return this.getCrossScore({pgid: row.endpgid, psucomid: item.comid})
                    }
                  }
                }
              ],
              showOverflow: true
            })
          }
        }
      },
      fileClick (col, item) {
        this.downFile(item.appendurl)
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.projectid}
        })
        this.project = res
      },
      // 获取已检查结果，把结果值说明返回交叉表
      getCrossScore (item) {
        let model = this.pgsuList.find(v => +v.pgsucomid === +item.psucomid && (+v.pgsupgid === +item.pgid || v.pgname === '合计'))
        return model ? model.pgsuas : ''
      },
      // 汇总表的数据
      async getPgsList () {
        this.pgsList = await request({
          url: 'expert/getPgsByProjectId',
          method: "get",
          params: {
            pexpertid: this.pexpertid,
            projectid: this.projectid
          }
        })
      },
      // 导出PDF
      exportPDF() {
        this.btnLoading = true
        // 检查是否加载了html2canvas和jsPDF
        if (typeof html2canvas === 'undefined' || typeof jsPDF === 'undefined') {
          // 动态加载所需库
          const script1 = document.createElement('script')
          script1.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js'
          script1.onload = () => {
            const script2 = document.createElement('script')
            script2.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js'
            script2.onload = () => {
              this.generatePDF()
            }
            document.head.appendChild(script2)
          }
          document.head.appendChild(script1)
        } else {
          this.generatePDF()
        }
      },
      // 生成PDF
      generatePDF() {
        // 创建一个临时的导出表格
        const exportContainer = document.createElement('div')
        exportContainer.style.width = '100%'
        exportContainer.style.padding = '20px'
        exportContainer.style.backgroundColor = '#fff'
        
        // 添加标题
        const title = document.createElement('h2')
        title.style.textAlign = 'center'
        title.style.marginBottom = '15px'
        title.textContent = `评审人[${this.pexpert.pexpertname}]评分表`
        exportContainer.appendChild(title)
        
        // 添加项目信息（标题下方）
        const projectInfo = document.createElement('div')
        projectInfo.style.display = 'flex'
        projectInfo.style.justifyContent = 'space-between'
        projectInfo.style.marginBottom = '20px'
        
        const projectName = document.createElement('span')
        projectName.textContent = `项目名称：${this.project.projectname || ''}`
        projectInfo.appendChild(projectName)
        
        const projectCode = document.createElement('span')
        projectCode.textContent = `项目编号：${this.project.projectcode || ''}`
        projectInfo.appendChild(projectCode)
        
        exportContainer.appendChild(projectInfo)
        
        // 创建表格
        const table = document.createElement('table')
        table.style.width = '100%'
        table.style.borderCollapse = 'collapse'
        
        // 创建表头
        const thead = document.createElement('thead')
        const headerRow = document.createElement('tr')
        
        // 序号列
        const serialHeader = document.createElement('th')
        serialHeader.style.border = '1px solid #000'
        serialHeader.style.padding = '8px'
        serialHeader.style.textAlign = 'center'
        serialHeader.textContent = '序号'
        headerRow.appendChild(serialHeader)
        
        // 一级（项目）列
        const level1Header = document.createElement('th')
        level1Header.style.border = '1px solid #000'
        level1Header.style.padding = '8px'
        level1Header.style.textAlign = 'center'
        level1Header.textContent = '一级（项目）'
        headerRow.appendChild(level1Header)
        
        // 二级（评审内容）列
        const level2Header = document.createElement('th')
        level2Header.style.border = '1px solid #000'
        level2Header.style.padding = '8px'
        level2Header.style.textAlign = 'center'
        level2Header.textContent = '二级（评审内容）'
        headerRow.appendChild(level2Header)
        
        // 评分档次及依据列
        const criteriaHeader = document.createElement('th')
        criteriaHeader.style.border = '1px solid #000'
        criteriaHeader.style.padding = '8px'
        criteriaHeader.style.textAlign = 'center'
        criteriaHeader.textContent = '评分档次及依据'
        headerRow.appendChild(criteriaHeader)
        
        // 分值列
        const scoreHeader = document.createElement('th')
        scoreHeader.style.border = '1px solid #000'
        scoreHeader.style.padding = '8px'
        scoreHeader.style.textAlign = 'center'
        scoreHeader.textContent = '分值'
        headerRow.appendChild(scoreHeader)
        
        // 供应商列
        this.psuComList.forEach(item => {
          const supplierHeader = document.createElement('th')
          supplierHeader.style.border = '1px solid #000'
          supplierHeader.style.padding = '8px'
          supplierHeader.style.textAlign = 'center'
          supplierHeader.textContent = item.comfullname
          headerRow.appendChild(supplierHeader)
        })
        
        thead.appendChild(headerRow)
        table.appendChild(thead)
        
        // 创建表格内容
        const tbody = document.createElement('tbody')
        this.pgCrossList.forEach((row, index) => {
          const dataRow = document.createElement('tr')
          
          // 序号
          const serialCell = document.createElement('td')
          serialCell.style.border = '1px solid #000'
          serialCell.style.padding = '8px'
          serialCell.style.textAlign = 'center'
          serialCell.textContent = row.pgparentname === '合计' ? '' : index + 1
          dataRow.appendChild(serialCell)
          
          // 一级（项目）（合计行显示"合计"）
          const level1Cell = document.createElement('td')
          level1Cell.style.border = '1px solid #000'
          level1Cell.style.padding = '8px'
          level1Cell.style.whiteSpace = 'nowrap'
          level1Cell.textContent = row.pgparentname === '合计' ? '合计' : row.pgchildname
          dataRow.appendChild(level1Cell)
          
          // 二级（评审内容）
          const level2Cell = document.createElement('td')
          level2Cell.style.border = '1px solid #000'
          level2Cell.style.padding = '8px'
          level2Cell.textContent = row.pgchildchildname
          dataRow.appendChild(level2Cell)
          
          // 评分档次及依据
          const criteriaCell = document.createElement('td')
          criteriaCell.style.border = '1px solid #000'
          criteriaCell.style.padding = '8px'
          criteriaCell.textContent = row.pgremark
          dataRow.appendChild(criteriaCell)
          
          // 分值（合计行显示总分值并加粗）
          const scoreCell = document.createElement('td')
          scoreCell.style.border = '1px solid #000'
          scoreCell.style.padding = '8px'
          scoreCell.style.textAlign = 'center'
          scoreCell.textContent = row.pgscore
          if (row.pgparentname === '合计') {
            scoreCell.style.fontWeight = 'bold'
          }
          dataRow.appendChild(scoreCell)
          
          // 供应商评分（合计行加粗显示）
          this.psuComList.forEach(item => {
            const supplierCell = document.createElement('td')
            supplierCell.style.border = '1px solid #000'
            supplierCell.style.padding = '8px'
            supplierCell.style.textAlign = 'center'
            const score = this.getCrossScore({pgid: row.endpgid, psucomid: item.comid})
            supplierCell.textContent = score || ''
            if (row.pgparentname === '合计') {
              supplierCell.style.fontWeight = 'bold'
            }
            dataRow.appendChild(supplierCell)
          })
          
          tbody.appendChild(dataRow)
        })
        
        table.appendChild(tbody)
        exportContainer.appendChild(table)
        document.body.appendChild(exportContainer)
        
        // 使用html2canvas和jsPDF生成PDF
        const { jsPDF } = window.jspdf
        const pdf = new jsPDF('l', 'mm', 'a4')
        
        html2canvas(exportContainer, {
          scale: 2,
          useCORS: true,
          allowTaint: true
        }).then(canvas => {
          const imgData = canvas.toDataURL('image/png')
          const imgWidth = 297 // A4宽度
          const imgHeight = canvas.height * imgWidth / canvas.width
          
          pdf.addImage(imgData, 'PNG', 10, 10, imgWidth - 20, imgHeight)
          pdf.save(`评审评分_${this.pexpert.pexpertname}.pdf`)
          
          // 清理临时元素
          document.body.removeChild(exportContainer)
          this.btnLoading = false
        }).catch(err => {
          console.error('生成PDF失败', err)
          // 清理临时元素
          if (exportContainer.parentNode) {
            document.body.removeChild(exportContainer)
          }
          this.btnLoading = false
          this.$message.error('生成PDF失败')
        })
      },
      // 导出PDF（新版：表格结构与页面一致，一级（项目）合并展示，内容多时自动分页）
      async exportPDFNew () {
        if (this.btnLoadingNew) return
        if (!this.pgCrossList.length) {
          this.$message.warning('暂无可导出的评分数据')
          return
        }
        this.btnLoadingNew = true
        try {
          await ensurePdfLibs()
          await exportTablePdf(this.getPdfOptions())
        } catch (err) {
          console.error('导出评分表PDF（新版）失败', err)
          this.$message.error('导出PDF失败：' + ((err && err.message) || '未知错误'))
        } finally {
          this.btnLoadingNew = false
        }
      },
      // 组装导出PDF的数据：列、行都与页面表格一致（含供应商评分列与合计行）
      getPdfOptions () {
        const baseCols = this.pgCols.filter(col => !col.children)
        // 一级（项目）列：页面上按该列合并，导出时整组放在同一页
        const levelField = baseCols.length > 1 ? baseCols[1].field : ''
        const columns = baseCols.map(col => this.getPdfColumn(col))
        // 供应商列：每家供应商一列，列宽按数量自适应，避免把评审内容列挤掉
        const baseFixedWidth = columns.reduce((sum, col) => sum + (col.width || 0), 0)
        let supplierWidth = 100
        while (supplierWidth > 60 &&
        baseFixedWidth + this.psuComList.length * supplierWidth + 400 > RENDER_WIDTH) {
          supplierWidth -= 5
        }
        this.psuComList.forEach(com => {
          columns.push({key: 'com_' + com.comid, title: com.comfullname, width: supplierWidth})
        })
        return {
          fileName: `评审评分_${this.pexpert.pexpertname || ''}.pdf`,
          title: `评审人[${this.pexpert.pexpertname}]评分表`,
          titleContinuation: `评审人[${this.pexpert.pexpertname}]评分表（续）`,
          infoLeft: `项目名称：${this.project.projectname || ''}`,
          infoRight: `项目编号：${this.project.projectcode || ''}`,
          footerLeft: `评审人：${this.pexpert.pexpertname || ''}`,
          columns: columns,
          rows: this.pgCrossList.map(row => this.getPdfRow(row, baseCols, levelField)),
          mergeKey: levelField
        }
      },
      // 列配置：序号、分值等固定宽度，评审内容、评分依据按比例分配剩余宽度
      getPdfColumn (col) {
        const column = {key: col.field, title: col.title}
        switch (col.field) {
          case 'serialNumber':
            column.width = 45
            break
          case 'pgchildname':
            column.width = 110
            break
          case 'pgscore':
            column.width = 60
            break
          default:
            if (col.width) {
              column.width = col.width
            } else {
              // 长文本列：评分依据比评审内容更宽
              column.flex = col.field === 'pgremark' ? 7 : 3
              column.align = 'left'
              column.wrap = true
            }
        }
        return column
      },
      // 行数据：基础列按页面字段取值，供应商列取该供应商的评分
      getPdfRow (row, baseCols, levelField) {
        const isTotal = row.pgparentname === '合计'
        const data = {_total: isTotal}
        baseCols.forEach(col => {
          if (col.field === levelField) {
            // 一级（项目）列：合计行显示"合计"
            data[col.field] = isTotal ? '合计' : (row[col.field] || '')
          } else {
            data[col.field] = row[col.field] === null || row[col.field] === undefined ? '' : row[col.field]
          }
        })
        this.psuComList.forEach(com => {
          data['com_' + com.comid] = this.getCrossScore({pgid: row.endpgid, psucomid: com.comid}) || ''
        })
        return data
      }
    }
  }
</script>
<style lang="scss">
  .exscore-container {
    margin-top: 20px;
  }
  .exscore-topbtn {
    display: flex;
    align-items: center;
    width: 100%;
    .exscore-topbtn-title {
      padding-left: 10px;
      text-align: center;
    }
    .exscore-topbtn-btn {
      margin-left: auto;
      padding-right: 10px;
    }
    .exscore-topbtn-btn .el-button + .el-button {
      margin-left: 8px;
    }
  }
  .exscore-footbtn {
     text-align: right;
     padding-top: 10px;
   }
</style>
